import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { useForceLightMode } from "@/hooks/useTheme";
import { EmailLineSection } from "@/components/home/EmailLineSection";
import { FaqSection } from "@/components/home/FaqSection";
import { FinalCtaSection } from "@/components/home/FinalCtaSection";
import { HeroStage } from "@/components/home/HeroStage";
import { HomeFooter } from "@/components/home/HomeFooter";
import { HomeHeader } from "@/components/home/HomeHeader";
import { HowStepsSection } from "@/components/home/HowStepsSection";
import { ModelsSection } from "@/components/home/ModelsSection";
import { SocialsSection } from "@/components/home/SocialsSection";
import { SecondBrainSection } from "@/components/home/SecondBrainSection";
import { SelfCompletingSection } from "@/components/home/SelfCompletingSection";
import { StartSection } from "@/components/home/StartSection";
import { TrustSection } from "@/components/home/TrustSection";

export const Route = createFileRoute("/")({
  component: LandingRoute,
});

function LandingRoute() {
  useForceLightMode();

  // Deep links like /#pricing: content renders after the browser's native
  // anchor pass, and the hero canvas growing afterwards shifts offsets, so
  // jump once when sections exist and correct once more after layout settles.
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const jump = () => document.querySelector(hash)?.scrollIntoView();
    const first = setTimeout(jump, 150);
    const settle = setTimeout(jump, 1400);
    return () => {
      clearTimeout(first);
      clearTimeout(settle);
    };
  }, []);

  return (
    <div className="relative flex min-h-screen flex-col bg-home-cream pt-[104px] font-body text-home-ink md:pt-16">
      <HomeHeader />
      <HeroStage />
      <SelfCompletingSection />
      <SecondBrainSection />
      <SocialsSection />
      <EmailLineSection />
      <TrustSection />
      <ModelsSection />
      {/* Pricing sits right after the pillars: the reader has the whole value
          prop and the safety answer, and shouldn't have to hunt past utility
          blocks to find out what it costs. How-it-works and the FAQ then serve
          whoever is still deciding. */}
      <StartSection />
      <HowStepsSection />
      <FaqSection />
      <FinalCtaSection />
      <HomeFooter />
    </div>
  );
}
